import { create } from 'zustand'

interface SupportSearchState {
	/** The tax code, email or protocol the admin searched last; empty when none. */
	term: string
	setTerm: (next: string) => void
}

/**
 * What the general admin typed in the support console. It is a student's
 * personal data, so it lives in the memory of the page and nowhere else: not in
 * the address, not in the history state and not in the browser storage, which a
 * next user of the same device would find. A reload forgets it, and signing out
 * (or a session the backend declared dead) clears it with `clearSupportSearch`.
 */
export const useSupportSearch = create<SupportSearchState>()((set) => ({
	term: '',
	setTerm: (term) => set({ term })
}))

export function clearSupportSearch() {
	useSupportSearch.getState().setTerm('')
}
